"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttachmentUrl = getAttachmentUrl;
/**
 * Build a browser-safe URL for an event attachment.
 * Uses the attachment's `readToken` for auth (no embedded credentials in the URL).
 *
 * @param connection - Pryv Connection (uses `.endpoint` for the clean base URL)
 * @param event - Pryv event with attachments
 * @param attachmentIndex - index of the attachment (default 0)
 * @returns URL string or null if no attachment at the given index
 */
function getAttachmentUrl(connection, event, attachmentIndex = 0) {
    if (!event.attachments?.[attachmentIndex])
        return null;
    const attachment = event.attachments[attachmentIndex];
    const baseUrl = (connection.endpoint || '').replace(/\/$/, '');
    return `${baseUrl}/events/${event.id}/${attachment.id}?readToken=${attachment.readToken}`;
}
